import * as React from 'react';

import type { ThemeColor } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $colorMode } from '../_state/preferences.state';
import type { CalendarEvent } from '../types/calendarEvent';
import {
  DEFAULT_ENTITY_TYPE_COLORS,
  DEFAULT_MODULE_COLORS,
  DEFAULT_STATUS_COLORS,
} from '../utils/colorDefaults';

export function useColorResolver(): (event: CalendarEvent) => ThemeColor {
  const colorMode = useAtomValue($colorMode);

  return React.useCallback(
    (event: CalendarEvent): ThemeColor => {
      switch (colorMode) {
        case 'byModule':
          return DEFAULT_MODULE_COLORS[event.module] || 'neutral';
        case 'byEntityType':
          return DEFAULT_ENTITY_TYPE_COLORS[event.source] || 'neutral';
        case 'byStatus':
          return DEFAULT_STATUS_COLORS[event.status || ''] || 'neutral';
        default:
          return 'neutral';
      }
    },
    [colorMode],
  );
}
